import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

const CabinetContestMain = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Розыгрыши')}</div>
                <div className={`${Styles.contentWrapNote}`}>
                    {t('30% прибыли компании с каждого круга направляется на розыгрыш среди всех покупателей токенов в текущем раунде. Случайным образом выбираются 20 победителей, которые получают повышенные призы. Оставшаяся часть фонда распределяется между другими участниками — каждый получает минимальный денежный приз, эквивалентный стоимости одного токена текущего круга, до полного использования всей суммы.')}
                </div>
            </div>
        </section>
    );
};

export default CabinetContestMain;